import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const UnlimitedTagContainer = styled.div`
  background: ${palette.pricingLightGreen};
  border-radius: 2px;
  display: grid;
  justify-content: center;
  padding: 1px 4px;
  max-width: 95px;
  margin: 0 auto;

  @media screen and (max-width: ${layout.sm}) {
    width: min-content;

    > span {
      font-size: 13px;
    }
}
`
